(function () {
  'use strict';

  /* @ngdoc object
   * @name reminder
   * @description
   *
   */
  angular
    .module('reminder', [
      'ui.router',
      'ui.bootstrap'
    ]);
}());
